import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName][appPreventSpace]',
})

export class PreventSpaceDirective {

  constructor(public ngControl: NgControl) { }

  @HostListener('input', ['$event'])
  onInputEvent(event: InputEvent) {
    this.updateControlAndDomValues(event, (event.target as HTMLInputElement).value);
  }

  private updateControlAndDomValues(event: InputEvent, value: string) {
    
    // Return early if there's no whitespace
    if (!value.includes(' ')) {
      return;
    }

    let trimmedValue = value.trim();

    this.ngControl.control.setValue(trimmedValue);
    this.ngControl.control.markAsDirty({ onlySelf: true });

    if (event) {
      (event.target as HTMLInputElement).value = trimmedValue;
    }
  }
}
